import { useContext, useEffect, useState } from "react";
import {
  OpenGraphMetadata,
  getOpenGraphMetadata
} from "@coxauto-ui/cxm/communications/api";
import { ConversationContext } from "../context";

// cspell:ignore TRUVIDEO truvideo vidplat vinsolutions
// The literal `.` before each host rejects a look-alike like `truvideo-evil.com`.
const TRUVIDEO_ENDLINK_PATTERN =
  /https?:\/\/(?:[a-zA-Z0-9-]+\.)*(?:truvideo\.com|vid-plat\.com|media\.vinsolutions\.com)\/\S+/i;

export function extractEndlinkUrl(text: string): string | null {
  const match = text.match(TRUVIDEO_ENDLINK_PATTERN);
  return match ? match[0].replace(/[.,!?)]+$/, "") : null;
}

export function extractAllEndlinkUrls(text: string): string[] {
  // Create regex with g flag locally to avoid lastIndex state issues
  const pattern = new RegExp(TRUVIDEO_ENDLINK_PATTERN.source, "gi");
  const matches = text.match(pattern);
  if (!matches) return [];
  return matches.map(m => m.replace(/[.,!?)]+$/, ""));
}

export function useOpenGraphMetadata(text: string) {
  const { env } = useContext(ConversationContext);
  const [metadata, setMetadata] = useState<OpenGraphMetadata | null>(null);

  const endlinkUrl = extractEndlinkUrl(text);

  useEffect(() => {
    if (!endlinkUrl) return;

    let cancelled = false;

    getOpenGraphMetadata(endlinkUrl, env).then(result => {
      if (!cancelled && result) {
        // Fall back to the endlink URL if the BFF didn't return a url field
        setMetadata({ ...result, url: result.url || endlinkUrl });
      } else if (!cancelled) {
        setMetadata(result);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [endlinkUrl, env]);

  return { metadata, endlinkUrl };
}
